// extracted by mini-css-extract-plugin
export default {"galleryContainer":"ShowGallery_galleryContainer__-ulfN","galeryBlockImg":"ShowGallery_galeryBlockImg__hYFjt","paginationWrapper":"ShowGallery_paginationWrapper__Svb5+"};